import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import CourseItem from "../components/CourseItem";
import SubCategoriesFilter from "../components/SubCategoriesFilter";
import CategorySkeleton from "../components/skeleton/CategorySkeleton";
import { Alert } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import { PROXY, fetchData } from "../lib/utils";

const Category = () => {
  const { id } = useParams();
  const { i18n, t } = useTranslation();

  const [subId, setSubId] = useState(null);
  const [showWarning, setShowWarning] = useState(false);

  // Safe fetcher function
  const fetcher = useCallback(async (url) => {
    try {
      return await fetchData(url, "accessToken");
    } catch (err) {
      console.error("Fetcher error:", err);
      throw err;
    }
  }, []);

  const { data, error, isLoading } = useSWR(
    `${PROXY}/categories/client/${id}${subId ? `?filter=${subId}` : ""}`,
    fetcher
  );

  // Show warning if no courses found
  useEffect(() => {
    if (data?.data?.length === 0) {
      setSubId(null);
      setShowWarning(true);
    }
  }, [data]);

  // Hide warning after 5 seconds
  useEffect(() => {
    if (!showWarning) return;

    const timer = setTimeout(() => setShowWarning(false), 5000);
    return () => clearTimeout(timer);
  }, [showWarning]);

  if (error) return <div className="text-red-500">Error: {error.message}</div>;
  if (isLoading) return <CategorySkeleton />;

  const categoryData = data?.data?.[0] || {};
  const courses = data?.data || [];
  const categoryName = categoryData?.category?.name?.[i18n.language] || "";

  return (
    <section
      className="px-4 mx-auto sm:max-w-5xl sm:px-6 lg:max-w-7xl lg:px-8 my-10 overflow-hidden"
      id="courses"
    >
      <h2 className="text-sm lg:text-3xl font-semibold mb-8">
        {categoryName} {t("related-courses")}
      </h2>

      {showWarning && (
        <Alert color="yellow" className="mb-4">
          {t("Related Category courses Coming soon!")}
        </Alert>
      )}

      <SubCategoriesFilter
        subId={subId}
        setSubId={setSubId}
        isName={false}
        subCategories={categoryData?.filterCategories || []}
      />

      <div className="relative grid gap-5 sm:grid-cols-1 lg:grid-cols-4">
        {courses.map((course) => (
          <CourseItem key={course._id} course={course} />
        ))}
      </div>
    </section>
  );
};

export default Category;
